export function main (_p5) {
  let p5
  p5 = _p5
  let parentWidth, parentHeight
  let dim
  let img, mono
  let imgMax, imgMin, shorterEdge
  p5.preload = () => {
    p5.frameRate(60)
    const parentDiv = document.getElementById('complement-canvas-wrapper')
    parentWidth = parentDiv.offsetWidth
    parentHeight = parentDiv.offsetHeight
    dim = Math.min(parentWidth, parentHeight)
    img = p5.loadImage('../static/complement-images/complement-col.jpg')
    mono = p5.loadImage('../static/complement-images/complement-mono.jpg')
  }
  p5.setup = _ => {
    // const canvas = p5.createCanvas(parentWidth, parentHeight)
    // canvas.parent('Complement-canvas')
    imgMax = Math.max(img.width, img.height)
    imgMin = Math.min(img.width, img.height)
    shorterEdge = (dim / imgMax) * imgMin
    if (imgMax === img.width) {
      img.resize(dim, (dim / imgMax) * imgMin)
      mono.resize(dim, (dim / imgMax) * imgMin)
      const canvas = p5.createCanvas(dim, shorterEdge)
      canvas.parent('Complement-canvas')
      p5.image(mono, 0, 0, dim, shorterEdge)
    } else if (imgMax === img.height) {
      img.resize((dim / imgMax) * imgMin, dim)
      mono.resize((dim / imgMax) * imgMin, dim)
      const canvas = p5.createCanvas(shorterEdge, dim)
      canvas.parent('Complement-canvas')
      p5.image(mono, 0, 0, shorterEdge, dim)
    }
  }

  p5.draw = () => {
    if (p5.frameCount > 18000) p5.noLoop()
    // noStroke();
    const scl = 17
    for (let i = 0; i < 1; i++) {
      const x = p5.round(p5.random(parentWidth))
      const y = p5.round(p5.random(parentHeight))
      const c = img.get(x, y)
      // console.log(c)
      p5.stroke(c)
      p5.strokeWeight(0.5)
      p5.line(x, y - scl, x, y + scl)
      p5.line(x - scl, y, x + scl, y)
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/Complement.js